import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useClient from 'hooks/useClient'
import PageTable from '../../../components/PageTable'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import { ICONS, PERMISSIONS } from '../../../utils/constants'
import { getBooklets } from '../../../redux/actions/booklets'

const Booklets = () => {
  const { t } = useTranslation()
  const { isClientCan } = useClient()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const canCreateBooklets = isClientCan(PERMISSIONS.CREATE_BOOKLETS)

  const { items, pagination, isGetLoading } = useSelector((state) => state.booklets)

  useEffect(() => {
    dispatch(getBooklets({ page: 1, size: pagination.pageSize }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = useMemo(
    () =>
      [
        {
          title: '№',
          dataIndex: 'id',
          render: (text, record, index) => index + 1,
          key: 'id',
          align: 'center',
          width: '5%',
        },
        {
          title: t('booklets.field.purchaseProduct', 'Purchase product'),
          dataIndex: ['purchaseProduct', 'title'],
          key: 'purchaseProduct',
        },
        {
          title: t('booklets.field.redeemProduct', 'Redeem product'),
          dataIndex: ['redeemProduct', 'title'],
          key: 'redeemProduct',
        },
      ].filter(Boolean),
    [t],
  )

  const tableChangeHandler = (paginationConfig) => {
    dispatch(
      getBooklets({
        page: paginationConfig.current,
        size: paginationConfig.pageSize,
      }),
    )
  }

  return (
    <PageTable
      pageTitle={t('booklets.title', 'Booklets')}
      action={
        canCreateBooklets ? (
          <Button type="primary" onClick={() => navigate('/main/booklets/add')}>
            <Icon icon={ICONS.PLUS} className="btn-icon-suffix" />
            <span className="btn-text">{t('booklets.add button', 'Add booklet')}</span>
          </Button>
        ) : null
      }
      baseData={items}
      columns={columns}
      onRow={(record) => ({
        onClick: () => navigate(`/main/booklets/view/${record.id}`),
      })}
      loading={isGetLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        showSizeChanger: pagination.total >= 10,
      }}
      onChange={tableChangeHandler}
    />
  )
}

export default Booklets
